export default class Filter {
  constructor(type, value) {
    this.type = type

    if (value !== null && value !== undefined) {
      this.setSelectedOptionByValue(value)
    }
  }

  setSelectedOption({ value, name, data }) {
    this.value = value
    this.name = name

    if (data) {
      this.data = { ...data }
    }
  }

  setSelectedOptionByValue(value) {
    const selectedOption = this.type.getOption(value)

    if (!selectedOption) {
      try {
        const { origin, pathname } = window.location

        if (pathname.includes('/online/')) {
          const { href } = new URL('/online/vrach/?spec_not_available', origin)

          window.location.assign(href)
        }
      } catch { /* Empty */ }

      return
    }

    this.setSelectedOption(selectedOption)
  }

  isDefault() {
    if (this.type.isDefault) {
      return this.type.isDefault(this)
    }

    const defaultOption = this.type.getDefault()

    return this.name === defaultOption.name && this.value === defaultOption.value
  }

  reset() {
    this.setSelectedOption(this.type.getDefault())
  }
}
